// extracted by mini-css-extract-plugin
export default {"container":"map_container__+GKeW"};